import { render, staticRenderFns } from "./addCourse.vue?vue&type=template&id=07007177&"
import script from "./addCourse.vue?vue&type=script&lang=js&"
export * from "./addCourse.vue?vue&type=script&lang=js&"
import style0 from "./addCourse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports